import { Fade, Menu as MenuMUI } from '@mui/material';
import { ReactNode } from 'react';

import { ContextMenuItem } from './components/ContextMenuItem';
import { MenuContext } from './context/MenuContext';
import { ContextMenuDivider } from './components/ContextMenuDivider';

export type ContextMenuProps = {
  closeMenu: () => void;
  children: ReactNode;
  anchor: null | HTMLElement;
  width?: number;
  color?: 'light' | 'dark';
  variant?: 'compact';
  borderRadius?: number; // temp override for plugin
  'data-testid'?: string;
};

export const ContextMenu = ({
  children,
  anchor,
  width,
  closeMenu,
  variant,
  color,
  borderRadius,
  'data-testid': dataTestId,
}: ContextMenuProps) => {
  const open = !!anchor;

  return (
    <MenuMUI
      data-testid={dataTestId}
      anchorEl={anchor}
      open={open}
      onClose={closeMenu}
      TransitionComponent={Fade}
      sx={{ padding: 0 }}
      MenuListProps={{
        sx: {
          padding: 0,
        },
      }}
      slotProps={{
        paper: {
          sx: {
            border:
              color === 'light'
                ? '1px solid var(--stroke-stroke-primary-color)'
                : 'none',
            width: width || undefined,
            transform: 'translate(-8px, 8px)',
            background:
              color === 'light'
                ? '#fff'
                : 'var(--button-button-secondary-color)',
            padding: variant === 'compact' ? 0 : 2,
            borderRadius: borderRadius || variant === 'compact' ? 2 : 4,
            boxShadow:
              color === 'light' ? '0 2px 6px 0 rgba(0,0,0,0.1)' : 'none',
          },
        },
      }}
    >
      <MenuContext.Provider
        value={{
          closeMenu,
          variant,
          color,
        }}
      >
        {children}
      </MenuContext.Provider>
    </MenuMUI>
  );
};

ContextMenu.Item = ContextMenuItem;
ContextMenu.Divider = ContextMenuDivider;
